import { NotificationChannelEnum } from "./NotificationChannelEnum";
import { NotificationTopicEnum } from "./NotificationTopicEnum";

export class NotificationSubscriptionClientData {
    topic: NotificationTopicEnum;
    installationNames: string[];
    active: boolean;
    channel: NotificationChannelEnum;
    extraData: string;

    get topicString(): string {
        let res = "";
        switch (this.topic) {
            case NotificationTopicEnum.NewInstallationRegistration:
                res = "notifications.subscriptionTopics.newInstallationRegistration";
                break;
            case NotificationTopicEnum.ContentThresholdWarning:
                res = "notifications.subscriptionTopics.contentThresholdWarning";
                break;
            case NotificationTopicEnum.OutOfServiceStatus:
                res = "notifications.subscriptionTopics.outOfServiceStatus";
                break;
            case NotificationTopicEnum.CleanThresholdWarning:
                res = "notifications.subscriptionTopics.cleanThresholdWarning";
                break;
            case NotificationTopicEnum.OneTimeCodeNotifications:
                res = "notifications.subscriptionTopics.oneTimeCodeNotifications";
                break;
            case NotificationTopicEnum.BagFillPercentExceededWarning:
                res = "notifications.subscriptionTopics.bagFillPercentExceededWarning";
                break;
            case NotificationTopicEnum.IntegrationExceptionWarning:
                res = "notifications.subscriptionTopics.integrationExceptionWarning";
                break;
        }
        return res;
    }

    get channelString(): string {
        let res = "";
        switch (this.channel) {
            case NotificationChannelEnum.Mail:
                res = "notifications.subscriptionChannel.mail";
                break;
        }
        return res;
    }

    static parse(data: any): NotificationSubscriptionClientData {
        let res = new NotificationSubscriptionClientData();

        res.topic = data.Topic;
        res.active = data.Active;
        res.channel = data.Channel;
        res.extraData = data.ExtraData;

        if (data.InstallationNames) {
            res.installationNames = data.InstallationNames.filter((c) => c);
        }

        return res;
    }
}
